import { render, staticRenderFns } from "./VerkInvoiceItemList.vue?vue&type=template&id=e678246a&scoped=true&"
import script from "./VerkInvoiceItemList.vue?vue&type=script&lang=ts&"
export * from "./VerkInvoiceItemList.vue?vue&type=script&lang=ts&"
import style0 from "./VerkInvoiceItemList.vue?vue&type=style&index=0&id=e678246a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e678246a",
  null
  
)

export default component.exports